import { gql } from "@apollo/client";
import apolloClient from "../graphql";
import { GET_FEE_CODES } from "../graphql/queries/feeCodes";

export async function getFeeCodes() {
  const response = await apolloClient
    .query({
      query: GET_FEE_CODES,
      variables: {}
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function getFeeCodesPrice(data) {
  const query = gql`query feePrices{
                feeCode : fee(request: { feeCode: "${data.feeCode}", passengerKey: "${data.paxKey}" }) {
                  amount
                }
            }`;
  const response = await apolloClient
    .query({
      query,
      variables: {}
    })
    .catch((err) => {
      console.warn(err);
    });
  return response;
}
